import React from 'react';

export default ({
	EN: {
		appointmentStatus: (success, usingClick) => {
			if (!success) {
				return `We're Sorry.`;
			}
			return usingClick ? 'Appointment Confirmed' : 'Appointment Requested - Pending Review';
		},
		confirmationNo: (success, num, usingClick) => {
			if (!success) {
				return 'The scheduling system is temporarily down.';
			}
			return usingClick ? `Confirmation #${num}` : `Request #${num}`;
		},
		thankYou: (success, usingClick) => {
			if (!success) {
				return 'Our engineers are working hard to resolve the issue.';
			}
			if (usingClick) {
				return 'Thank you for scheduling an appointment with Manheim Mobile Inspections.';
			}
			return (
				<span>
					<strong>Your appointment has NOT yet been set.</strong> We strive to contact customers within 24 hours to confirm this date or offer an alternative. During periods of high demand, response times may vary. If you need immediate assistance, please contact our dispatch office at 866-621-9123. We appreciate your patience and look forward to assisting you.
				</span>
			);
		},
		youWillReceiveEmail: (success, email) => success ?
			(<span>You will receive an email confirmation shortly at <span className='email'>{email}</span>.</span>) :
			'Please start over again. If the issue persists, please report the issue and we will contact you as soon as possible.',
		youCanCloseThisWindow: 'You can now close this window.',
		startOver: 'Start over',
		pageTitle: 'Confirmation'
	},
	ES: {
		appointmentStatus: (success, usingClick) => {
			if (!success) {
				return 'Lo Sentimos';
			}
			return usingClick ? 'Cita Confirmada' : 'Solicitud de Cita - Pendiente de Revisión';
		},
		confirmationNo: (success, num, usingClick) => {
			if (!success) {
				return 'El sistema de programación está temporalmente inactivo.';
			}
			return usingClick ? `Número de Confirmación #${num}` : `Número de Solicitud #${num}`;
		},
		thankYou: (success, usingClick) => {
			if (!success) {
				return 'Nuestros ingenieros están trabajando duro para resolver el problema';
			}
			if (usingClick) {
				return 'Gracias por programar una cita con Manheim Mobile Inspections.';
			}
			return (
				<span>
					<strong>Su cita aún NO se ha establecido.</strong> Nos esforzamos por contactar a los clientes dentro de las 24 horas para confirmar esta fecha u ofrecer una alternativa. Durante períodos de alta demanda, los tiempos de respuesta pueden variar. Si necesita asistencia inmediata, comuníquese con nuestra oficina de despacho al 866-621-9123. Agradecemos su paciencia y esperamos poder ayudarle.
				</span>
			);
		},
		youWillReceiveEmail: (success, email) => success ?
			(<span>Usted recibirá un correo electrónico de confirmación en breve en <span className='email'>{email}</span>.</span>) :
			'Por favor empezar de nuevo. Si el problema persiste, comuníquese el problema y nos pondremos en contacto con usted lo antes posible.',
		youCanCloseThisWindow: 'Ahora puede cerrar esta ventana.',
		startOver: 'Comenzar de nuevo',
		pageTitle: 'Confirmación'
	}
});
